const summary_cards = [
  { label: 'DEPARTMENTS', value: '6', note: 'Reporting lines' },
  { label: 'BUSINESS UNITS', value: '11', note: 'Cost & accountability' },
  { label: 'REGIONS', value: '3', note: 'Geographic' },
  { label: 'HEADCOUNT', value: '288', note: 'Active employees' }
];

const reporting_tree = [
  {
    id: 'accounting_officer',
    title: 'Accounting Officer / CEO',
    meta: 'Executive',
    icon: 'bi-person-badge',
    tone: 'success',
    children: [
      {
        id: 'finance',
        title: 'Finance',
        meta: 'CFO - M. Khan · Gauteng - 24 staff',
        icon: 'bi-building',
        tone: 'info',
        status: 'Monitoring',
        status_class: 'bg-warning-subtle text-warning-emphasis',
        children: [
          { id: 'procurement_scm', title: 'Procurement / SCM', meta: 'SCM Manager · 8 staff', icon: 'bi-people', tone: 'neutral' },
          { id: 'accounts_payable', title: 'Accounts payable', meta: 'J. Moyo · 6 staff', icon: 'bi-people', tone: 'neutral' }
        ]
      },
      {
        id: 'operations',
        title: 'Operations',
        meta: 'COO · Multi-region - 92 staff',
        icon: 'bi-building',
        tone: 'info',
        status: 'Monitoring',
        status_class: 'bg-warning-subtle text-warning-emphasis',
        children: [
          { id: 'facilities', title: 'Facilities', meta: 'Facilities Manager · Sites - 18 staff', icon: 'bi-people', tone: 'neutral', status: 'Open issues', status_class: 'bg-danger-subtle text-danger-emphasis' },
          { id: 'central_warehouse', title: 'Central warehouse', meta: 'Warehouse Lead · Gauteng - 22 staff', icon: 'bi-people', tone: 'neutral' }
        ]
      },
      {
        id: 'legal_compliance',
        title: 'Legal & Compliance',
        meta: 'CCO - P. Naidoo · Head office - 12 staff',
        icon: 'bi-building',
        tone: 'info',
        status: 'Open issues',
        status_class: 'bg-danger-subtle text-danger-emphasis',
        children: [
          { id: 'information_office', title: 'Information Office', meta: 'Information Officer · POPIA - 3 staff', icon: 'bi-people', tone: 'neutral' },
          { id: 'risk', title: 'Risk', meta: 'CRO · 4 staff', icon: 'bi-people', tone: 'neutral' }
        ]
      },
      {
        id: 'it',
        title: 'IT',
        meta: 'CIO · 15 staff',
        icon: 'bi-building',
        tone: 'info',
        status: 'Monitoring',
        status_class: 'bg-warning-subtle text-warning-emphasis',
        children: [
          { id: 'it_security', title: 'IT Security', meta: 'CISO - R. Govender · Cyber - 6 staff', icon: 'bi-people', tone: 'neutral' }
        ]
      },
      { id: 'human_resources', title: 'Human Resources', meta: 'HR Director · 19 staff', icon: 'bi-building', tone: 'info' },
      {
        id: 'programmes',
        title: 'Programmes',
        meta: 'Programme Manager · Funded projects - KZN',
        icon: 'bi-building',
        tone: 'info',
        children: [
          { id: 'durban_training_centre', title: 'Durban training centre', meta: 'Centre Lead · Skills programme', icon: 'bi-people', tone: 'neutral' },
          { id: 'soweto_community_clinic', title: 'Soweto community clinic', meta: 'Clinic Manager · Health facility', icon: 'bi-people', tone: 'neutral', status: 'Open issues', status_class: 'bg-danger-subtle text-danger-emphasis' }
        ]
      }
    ]
  }
];

const regions = [
  { label: 'Gauteng', meta: '4 sites - 186 staff', status: 'At risk', status_class: 'bg-danger-subtle text-danger-emphasis' },
  { label: 'Western Cape', meta: '1 site - 64 staff', status: 'Clear', status_class: 'bg-success-subtle text-success-emphasis' },
  { label: 'KwaZulu-Natal', meta: '2 sites - 38 staff', status: 'Monitoring', status_class: 'bg-warning-subtle text-warning-emphasis' }
];

export default {
  name: 'OrganisationStructure',
  data: () => ({
    summary_cards,
    reporting_tree,
    regions,
    open_nodes: {
      accounting_officer: true,
      finance: true,
      operations: true,
      legal_compliance: true,
      it: true,
      programmes: true
    }
  }),
  methods: {
    is_open(node_id) {
      return Reflect.get(this.open_nodes, node_id) !== false;
    },
    toggle_node(node_id) {
      Reflect.set(this.open_nodes, node_id, !this.is_open(node_id));
    }
  }
};
